/**
 * Include the Youtube api in the page.
 * This is heavy. Only call this if you absolutely need to play a video.
 */
const YOUTUBE_IFRAME = 'https://www.youtube.com/iframe_api'

export const loadYoutube = (id) => {
  const scriptTag = document.getElementById(id)
  if (!scriptTag) {
    return new Promise((res) => {
      const script = document.createElement('script')
      script.id = id
      script.onload = res
      script.src = YOUTUBE_IFRAME
      document.body.append(script)
    })
  } else {
    Promise.resolve()
  }
}
